<script>
import SpeedWave from './SpeedWave/SpeedWave.vue'
import SpeedThdChart from './SpeedThdChart/SpeedThdChart.vue'
import SpeedThdTable from './SpeedThdTable/SpeedThdTable.vue'
import {formatTime} from '../../utils'
export default {
  name: 'Speed',
  components: {
    SpeedWave,
    SpeedThdChart,
    SpeedThdTable
  },
  data () {
    return {
      page: 1,
      findTimeSelectOptions: [],
      findTimeSelectValue: 0,
      fastData: {},
      commandInterval: null,
      // countSelectValue: 0
      interval: null
    }
  },
  computed: {
  },
  watch: {
    findTimeSelectValue (val) {
      this.updateData()
      this.sendCommand(val)
    }
  },
  mounted () {
    this.pollCommand()
    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.updateData()
      }, 1000)
    }
  },
  destroyed () {
    this.pollStop()
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  methods: {
    formatTime,
    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand(0xff)
        if (!this.commandInterval) {
          this.commandInterval = setInterval(() => {
            this.sendCommand(this.findTimeSelectValue)
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.commandInterval) {
        clearInterval(this.commandInterval)
        this.commandInterval = null
      }
    },
    sendCommand (index) {
      // const m = (index + 1) << 4 & 0xf0 | 0x02
      const params = {
        sn: this.$store.state.sn,
        lists: [[1, 9, index]]
      }
      this.$api.command(params).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    currentPage (page) {
      this.page = page
    },
    async updateData () {
      let params = {
        'collection': 'meter_fast_wave_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'time': this.findTimeSelectValue,
        'transpose': false
      }
      console.log('BB', params)
      const {data: res} = await this.$api.queryLastDatas(params)
      console.log('aaa', res)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      if (this.findTimeSelectOptions.length !== res.data.fast_times) {
        for (var i = 0; i < res.data.fast_times; i++) {
          var item = {}
          item.value = i
          item.label = '记录' + (i + 1)
          this.findTimeSelectOptions[i] = item
        }
      }
      this.fastData = res.data
    },
    reload () {
      location.reload()
    }
  }
}
</script>

<template>
  <div class="page">
    <div style="height: 40px; width: 100%; margin: 10px; margin-left: 0; border-bottom: 1px #d0d0d0 solid; display: flex;">
      <div style="width: 100%; display: flex; height: 35px; line-height: 35px; font-size: 20px">
        <div
          style="width: 20%; display: flex; align-items: center; margin-left: 20px;">
          <div style="width: 130px">高速采样记录</div>
          <div style="width: 150px; margin-left: 20px; margin-bottom: 5px">
            <el-select v-model="findTimeSelectValue" placeholder="请选择" size="20px">
              <el-option
                v-for="item in findTimeSelectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div
          style="width: 20%; display: flex; align-items: center; margin-left: 20px;">
          <div style="width: 50px">类型</div>
          <div style="width: 150px; margin-left: 10px">
            {{ fastData ? fastData.fast_reason === 1 ? '手动触发' : fastData.fast_reason === 2 ? '外部IO触发' : fastData.fast_reason === 3 ? '电能质量事件触发' : '' : '' }}
          </div>
        </div>
        <div
          style="width: 20%; display: flex; align-items: center; margin-left: 20px;">
          <div style="width: 100px">发生时刻</div>
          <div style="width: 250px; margin-left: 10px">
            {{ fastData ? formatTime(fastData.fast_ts * 1000, 'yyyy/MM/dd HH:mm:ss') : '' }}
          </div>
        </div>
        <div>
          <el-button style="width: 130px; font-size: 20px; margin-bottom: 10px" @click="reload">
              <div style="text-align: center">刷新</div>
          </el-button>
        </div>
      </div>
    </div>
    <div class="dataBorder" style="height: calc(90vh - 120px)">
      <SpeedWave v-if="page===1" :fastData="fastData"></SpeedWave>
      <SpeedThdChart v-if="page===2" :fastData="fastData"></SpeedThdChart>
      <SpeedThdTable v-if="page===3" :fastData="fastData"></SpeedThdTable>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="30"
      @current-change="currentPage">
    </el-pagination>
  </div>
</template>

<style scoped>
.page {
  width: 100%;
  height: 100%;
}

.dataBorder {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(90vh - 70px);
//overflow: auto; display: flex; flex-wrap: wrap;
  justify-content: space-between;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Speed/Speed.vue